// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"styles_mainWrapper__3MK6G","headerText":"styles_headerText__lFeCs","horizontalScrollWrapper":"styles_horizontalScrollWrapper__2Idro"};